import React, { useState } from 'react';
import {
  IconApps,
  IconChevronDown,
  IconDeviceDesktopAnalytics,
  IconHome2,
  IconUser,
  IconShoppingCart,
  IconArchive,
  IconReceipt2,
  IconBuildingStore,
  IconChartBar,
  IconWallet,
  IconDiamond,
  IconSettings,
  IconLogout,
  IconMenu2,
  IconX,
  IconClipboardList,
  IconBox,
  IconTags,
  IconShoppingCartOff,
  IconSun,
  IconMoon,
} from '@tabler/icons-react';
import { Link, NavLink, useNavigate } from 'react-router-dom';
import AddJenisBarang from '../components/Admin/AddJenisBarang';
import { useTheme } from '../context/ThemeContext';

const Navbar = () => {
  const [openMobile, setMobileOpen] = useState(false);
  const navigate = useNavigate();
  const { theme, toggleTheme } = useTheme();

  // ─── STYLING ───
  const activeNav = 'border-b-2 lg:flex items-center md:py-3 border-amber-500 text-amber-600 dark:text-amber-400 font-semibold transition-colors';
  const normalLink = 'block py-2 md:py-3 pl-2 sm:pl-1 align-middle lg:flex items-center text-slate-600 dark:text-slate-300 hover:text-amber-600 dark:hover:text-amber-400 transition-colors border-b-2 border-transparent hover:border-amber-400';

  function logout() {
    localStorage.removeItem('role');
    localStorage.removeItem('token');
    localStorage.removeItem('name');
    navigate('/login');
  }

  const check = localStorage.getItem('role');
  const user = localStorage.getItem('name');

  let [isOpen, setIsOpen] = useState(false);

  function closeModal() {
    setIsOpen(false);
  }
  function openModal() {
    setIsOpen(true);
  }

  return (
    <nav className="bg-gradient-to-r from-yellow-200/95 via-amber-100/95 to-yellow-200/95 dark:from-amber-900/40 dark:via-slate-900 dark:to-amber-900/40 backdrop-blur-md fixed w-full z-50 shadow-[0_4px_20px_-10px_rgba(0,0,0,0.1)] dark:shadow-[0_4px_20px_-10px_rgba(0,0,0,0.4)] border-b border-amber-300/60 dark:border-amber-700/50 transition-colors duration-300">
      <AddJenisBarang isOpen={isOpen} closeModal={closeModal} />
      <div className="w-full container mx-auto flex flex-wrap items-center mt-0 pt-3 pb-3 md:pb-0 px-4">

        {/* Brand Logo */}
        <div className="w-1/2">
          <Link to="/" className="text-gray-900 dark:text-white flex items-center text-lg xl:text-2xl font-bold tracking-tight hover:text-amber-600 dark:hover:text-amber-400 transition-colors">
            <div className="flex items-center justify-center w-8 h-8 rounded bg-gradient-to-br from-amber-400 to-amber-600 text-white mr-2.5 shadow-sm">
              <IconDiamond size={20} stroke={2} fill="currentColor" className="opacity-90 mt-0.5" />
            </div>
            <span className="bg-clip-text text-transparent bg-gradient-to-r from-amber-600 to-amber-800 dark:from-amber-400 dark:to-amber-600">
              Komaladewi
            </span>
          </Link>
        </div>

        {/* User Profile & Mobile Toggle */}
        <div className="w-1/2 flex justify-end items-center">
          {/* Theme toggle */}
          <button
            onClick={toggleTheme}
            className="p-2 rounded-lg text-slate-500 dark:text-slate-400 hover:text-amber-600 dark:hover:text-amber-400 hover:bg-amber-50 dark:hover:bg-slate-800 transition-colors mr-1"
            title={theme === 'light' ? 'Dark Mode' : 'Light Mode'}
          >
            {theme === 'light' ? <IconMoon size={20} /> : <IconSun size={20} />}
          </button>

          <div className="relative text-sm">
            <div className="dropdown dropdown-end">
              <label tabIndex={0} className="cursor-pointer flex items-center gap-2 group p-1.5 rounded-lg hover:bg-slate-50 dark:hover:bg-slate-800 transition-colors">
                <div className="w-8 h-8 rounded-full bg-amber-100 dark:bg-amber-900/40 text-amber-700 dark:text-amber-400 flex items-center justify-center font-bold shadow-inner border border-amber-200 dark:border-amber-700/50">
                  {user ? user.charAt(0).toUpperCase() : 'U'}
                </div>
                <div className="font-semibold text-slate-700 dark:text-slate-300 group-hover:text-amber-600 dark:group-hover:text-amber-400 transition-colors hidden sm:block">
                  {user}
                </div>
                <IconChevronDown size={16} className="text-slate-400 dark:text-slate-500 group-hover:text-amber-500 transition-colors" />
              </label>
              <div tabIndex={0} className="dropdown-content menu p-2 mt-2 shadow-lg bg-white dark:bg-slate-800 rounded-xl w-52 border border-slate-100 dark:border-slate-700">
                <div className="px-4 py-3 border-b border-slate-100 dark:border-slate-700 mb-1">
                  <p className="text-sm font-semibold text-slate-800 dark:text-slate-200 truncate">{user}</p>
                  <p className="text-xs text-slate-500 dark:text-slate-400 capitalize">{check}</p>
                </div>
                <button
                  onClick={logout}
                  className="w-full text-left py-2.5 px-3 flex items-center gap-2 text-red-600 dark:text-red-400 hover:bg-red-50 dark:hover:bg-red-900/20 hover:text-red-700 dark:hover:text-red-300 rounded-lg transition-colors font-medium text-sm"
                >
                  <IconLogout size={18} />
                  Log out
                </button>
              </div>
            </div>
          </div>

          {/* Mobile Menu Button */}
          <div className="block lg:hidden ml-4">
            <button
              onClick={() => setMobileOpen(!openMobile)}
              className="flex items-center p-2 rounded-md text-slate-500 dark:text-slate-400 hover:text-amber-600 dark:hover:text-amber-400 hover:bg-amber-50 dark:hover:bg-slate-800 focus:outline-none transition-colors"
            >
              {openMobile ? <IconX size={24} /> : <IconMenu2 size={24} />}
            </button>
          </div>
        </div>

        {/* Navigation Menu */}
        <div
          className={`${openMobile ? 'block' : 'hidden'
            } flex-grow lg:flex lg:items-center w-full lg:w-auto mt-4 lg:mt-0 bg-white dark:bg-slate-900 lg:bg-transparent pb-4 lg:pb-0 transition-colors`}
        >
          <div className="lg:flex flex-1 items-center gap-x-6 text-sm">

            {/* Dashboard */}
            <div className="my-1 lg:my-0">
              <NavLink to="/" className={({ isActive }) => (isActive ? activeNav : normalLink)}>
                <div className="flex items-center">
                  <IconHome2 size={20} className="mr-2" />
                  <span className="whitespace-nowrap">Dashboard</span>
                </div>
              </NavLink>
            </div>

            {/* Operator/Admin specific menus */}
            {check !== 'admin' && check !== 'operator' && (
              <>
                <div className="my-1 lg:my-0">
                  <NavLink to="/penjualan" className={({ isActive }) => (isActive ? activeNav : normalLink)}>
                    <div className="flex items-center">
                      <IconShoppingCart size={20} className="mr-2" />
                      <span className="whitespace-nowrap">Kasir Penjualan</span>
                    </div>
                  </NavLink>
                </div>
                <div className="my-1 lg:my-0">
                  <NavLink to="/transaksi-tertunda" className={({ isActive }) => (isActive ? activeNav : normalLink)}>
                    <div className="flex items-center">
                      <IconClipboardList size={20} className="mr-2" />
                      <span className="whitespace-nowrap">Kasir Penggarus</span>
                    </div>
                  </NavLink>
                </div>
                <div className="my-1 lg:my-0">
                  <NavLink to="/pembelian" className={({ isActive }) => (isActive ? activeNav : normalLink)}>
                    <div className="flex items-center">
                      <IconShoppingCart size={20} className="mr-2" />
                      <span className="whitespace-nowrap">Kasir Pembelian</span>
                    </div>
                  </NavLink>
                </div>
                <div className="my-1 lg:my-0">
                  <NavLink to="/pengembalian" className={({ isActive }) => (isActive ? activeNav : normalLink)}>
                    <div className="flex items-center">
                      <IconShoppingCartOff size={20} className="mr-2" />
                      <span className="whitespace-nowrap">Pengembalian</span>
                    </div>
                  </NavLink>
                </div>
                <div className="my-1 lg:my-0">
                  <NavLink to="/laporan-cashflow" className={({ isActive }) => (isActive ? activeNav : normalLink)}>
                    <div className="flex items-center">
                      <IconChartBar size={20} className="mr-2" />
                      <span className="whitespace-nowrap">Laporan</span>
                    </div>
                  </NavLink>
                </div>
              </>
            )}

            {/* Admin only menus */}
            {check !== 'kasir' && check !== 'operator' && (
              <>
                <div className="my-1 lg:my-0 lg:mt-[17px]">
                  <div className="dropdown dropdown-bottom lg:dropdown-hover w-full lg:w-auto">
                    <label
                      tabIndex={0}
                      className="block py-2 md:py-3 pl-2 sm:pl-1 align-middle cursor-pointer lg:flex items-center text-slate-600 dark:text-slate-300 hover:text-amber-600 dark:hover:text-amber-400 transition-colors border-b-2 border-transparent hover:border-amber-400"
                    >
                      <div className="flex items-center justify-between w-full lg:w-auto">
                        <div className="flex items-center">
                          <IconBuildingStore size={20} className="mr-2" />
                          <span className="whitespace-nowrap">Master Barang</span>
                        </div>
                        <IconChevronDown size={16} className="ml-1" />
                      </div>
                    </label>
                    <ul tabIndex={0} className="dropdown-content menu p-2 shadow-lg bg-white dark:bg-slate-800 rounded-xl w-full lg:w-52 border border-slate-100 dark:border-slate-700 z-[60]">
                      <li>
                        <button onClick={openModal} className="hover:bg-amber-50 dark:hover:bg-amber-900/20 hover:text-amber-700 dark:hover:text-amber-400 dark:text-slate-200 py-2.5">
                          <IconTags size={18} className="mr-2" />
                          Jenis Barang
                        </button>
                      </li>
                      <li>
                        <Link to="/list-items-admin" className="hover:bg-amber-50 dark:hover:bg-amber-900/20 hover:text-amber-700 dark:hover:text-amber-400 dark:text-slate-200 py-2.5">
                          <IconBox size={18} className="mr-2" />
                          Stok Barang
                        </Link>
                      </li>
                      <li>
                        <Link to="/barang-opname" className="hover:bg-amber-50 dark:hover:bg-amber-900/20 hover:text-amber-700 dark:hover:text-amber-400 dark:text-slate-200 py-2.5">
                          <IconArchive size={18} className="mr-2" />
                          Stok Opname
                        </Link>
                      </li>
                    </ul>
                  </div>
                </div>

                <div className="my-1 lg:my-0 lg:mt-[17px]">
                  <div className="dropdown dropdown-bottom lg:dropdown-hover w-full lg:w-auto">
                    <label
                      tabIndex={0}
                      className="block py-2 md:py-3 pl-2 sm:pl-1 align-middle cursor-pointer lg:flex items-center text-slate-600 dark:text-slate-300 hover:text-amber-600 dark:hover:text-amber-400 transition-colors border-b-2 border-transparent hover:border-amber-400"
                    >
                      <div className="flex items-center justify-between w-full lg:w-auto">
                        <div className="flex items-center">
                          <IconReceipt2 size={20} className="mr-2" />
                          <span className="whitespace-nowrap">Transaksi</span>
                        </div>
                        <IconChevronDown size={16} className="ml-1" />
                      </div>
                    </label>
                    <ul tabIndex={0} className="dropdown-content menu p-2 shadow-lg bg-white dark:bg-slate-800 rounded-xl w-full lg:w-52 border border-slate-100 dark:border-slate-700 z-[60]">
                      <li>
                        <Link to="/transaksi-penjualan" className="hover:bg-amber-50 dark:hover:bg-amber-900/20 hover:text-amber-700 dark:hover:text-amber-400 dark:text-slate-200 py-2.5">
                          Penjualan
                        </Link>
                      </li>
                      <li>
                        <Link to="/transaksi-pembelian" className="hover:bg-amber-50 dark:hover:bg-amber-900/20 hover:text-amber-700 dark:hover:text-amber-400 dark:text-slate-200 py-2.5">
                          Pembelian
                        </Link>
                      </li>
                      <li>
                        <Link to="/summary" className="hover:bg-amber-50 dark:hover:bg-amber-900/20 hover:text-amber-700 dark:hover:text-amber-400 dark:text-slate-200 py-2.5">
                          Laporan Ringkasan
                        </Link>
                      </li>
                    </ul>
                  </div>
                </div>

                <div className="my-1 lg:my-0">
                  <NavLink to="/list-users" className={({ isActive }) => (isActive ? activeNav : normalLink)}>
                    <div className="flex items-center">
                      <IconUser size={20} className="mr-2" />
                      <span className="whitespace-nowrap">Users</span>
                    </div>
                  </NavLink>
                </div>
              </>
            )}

            {/* Kasir/Admin Shared */}
            {check !== 'kasir' && check !== 'operator' && (
              <div className="my-1 lg:my-0">
                <NavLink to="/saldo-kas" className={({ isActive }) => (isActive ? activeNav : normalLink)}>
                  <div className="flex items-center">
                    <IconWallet size={20} className="mr-2" />
                    <span className="whitespace-nowrap">Saldo KAS</span>
                  </div>
                </NavLink>
              </div>
            )}

            {/* Operator Shared */}
            {check !== 'kasir' && (
              <div className="my-1 lg:my-0">
                <NavLink to="/tambah-barang" className={({ isActive }) => (isActive ? activeNav : normalLink)}>
                  <div className="flex items-center">
                    <IconDiamond size={20} className="mr-2" />
                    <span className="whitespace-nowrap">Tambah Barang</span>
                  </div>
                </NavLink>
              </div>
            )}
          </div>
        </div>
      </div>
    </nav>
  );
};

export default Navbar;
